import AuthenticationCodeConfirmation from './containers/AuthenticationCodeConfirmationContainer'

export default {
  path: '/authentication-code-confirmation',
  component: AuthenticationCodeConfirmation
}



// WEBPACK FOOTER //
// ./src/routes/authenticationCodeConfirmation/index.js